<template>
    <!-- Slider template for Activities section in Form 1 -->
    <div>
        <v-container grid-list-xs v-for="slider in sliders" :key="slider['id']">
            <p>{{slider.title}}</p>
            <v-layout row wrap>
                <v-flex xs6>
                    <v-slider thumb-label min="0" max="24" v-model="slider.model_day"/>
                    <label><span class="text">{{slider.model_day}}</span> Hours / Day </label>
                </v-flex>
                <v-flex xs6>
                    <v-slider thumb-label min="0" max="168" v-model="slider.model_week" />
                    <label><span class="text">{{slider.model_week}}</span> Hours / Week </label>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
export default {
    props:['sliders'],
    data(){
        return{
            window:{
                width: 0,
                height: 0
            }
        }
    },
    methods:{
        right(index){
            return index % 2 != 0 && this.window.width >= 480 ? 'right' : '';
        },
        responsiveStyle(){
            return this.window.width >= 480 ? 'width: 48%' : '';
        },
        handleResize(){
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
    created(){
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>
<style scoped>
    .text{
        color: black;
        font-size: 20px;
    }
</style>




